/**
 * @file refactor from umu_mobile
 */
import { isFeishu, isDingdingDesktop, isIosQQ, isUMUWebview, isMobileDomain, isInMpDesktop } from '@umu/umu-ua';
import { openUrlInMp, isFromMideaMiniApp } from 'common/src/services/util';
import { USEQuery } from '@umu/umu-util';
import { SendMsgType } from '@umu/umu-types';
import umuWebview from '@umu/umu-webview';
import { getQueryString } from './qs';
import { onDrawOpenByLink, IDrawerConfig } from './drawOpen';
export const $window = window;
export const $location = $window.location;
export const $document = document;
export const $history = history;
export const docElement = $document.documentElement || $document.body;

const getMHost = () => {
    let hostname = $location.hostname.replace(/www\./i, '');
    if (hostname.indexOf('m.') > -1) {
        return `${$location.protocol}//${hostname}`;
    } else {
        hostname = hostname.replace('test.', '');
        return `${$location.protocol}//m.${hostname}`;
    }
};
/**
 * 强制刷新
 * @param url
 */
export const forceRefreshPage = (url: string) => {
    // const reg = /([^\?]*)(\?[^#]*)?(#.*)?/i;  // todo 优化使用正则，按照url构成分成三部分
    // url = url || window.location.href;
    const currentUrl = url || window.location.href;
    // url = currentUrl.split('#');
    const split = currentUrl.split('#');
    const oldHash = split[1] || '';
    url = split[0];
    const urlSplit = url.split('?');
    const pathname = urlSplit[0];
    const search = urlSplit[1] || '';
    if (!pathname) {
        return;
    }

    const newSearch = search ? search.replace(/[&]?_r=[\.\d]+/gi, '') : '';
    const newUrl =
        pathname +
        (newSearch ? '?' + newSearch + '&' : '?') +
        '_r=' +
        Math.random().toFixed(3) +
        (oldHash ? '#' + oldHash : '');
    window.location.href = newUrl;
};

/**
 * url跳转
 */
export function redirectTo(url: string, isNotForceRefresh?: boolean, config?: IOpenConfig) {
    if (!url) {
        return;
    }
    openWindow(url, '_self', config);
    if (!isNotForceRefresh) {
        setTimeout(() => {
            forceRefreshPage(url);
        }, 2000);
    }
}

/**
 * url跳转
 */
export function redirectToWeb(path: string, isOpenWindow = false) {
    const host = $location.protocol + '//' + $location.host.replace('m.', '');
    const url = host + path;
    if (!isOpenWindow) {
        $window.location.href = url;
        setTimeout(() => {
            forceRefreshPage(url);
        }, 2000);
    } else {
        openWindow(url);
    }
}
/**
 * @desc 桌面端内部跳转（钉🆙、飞书）
 */
export const isInternalJump = () => isDingdingDesktop || isFeishu || isInMpDesktop;
/**
 * @desc 创建a标签跳转
 */
export const isCreateLinkJump = () => {
    return isIosQQ;
};
/**
 * 是否内嵌在USE首页
 */
export const isInUseHome = () => {
    const fromTo = getQueryString('fromTo') || getQueryString('from_to') || '';
    return isMicroAppChildren() && fromTo === 'useIndexPage';
};
/**
 * @desc openWindow
 */
interface IOpenConfig {
    _window?: Window;
    isRedirectToUmuApp?: boolean; // 是否需要在APP内部打开
    isOpenDrawer?: boolean; // 是否通过抽屉弹窗形式打开
    drawerConfig?: IDrawerConfig; // 抽屉配置
    enableMideaMiniAppNewVersion?: boolean; // 是否开启美的小程序最新版本功能
    /**
     * 后续支持App版本回调控制
     */
}
export const isMicroAppChildren = () => {
    const tmpWindow = window as any;
    if (!tmpWindow?.rawWindow) {
        return false;
    }
    const { __MICRO_APP_NAME__ = '', __MICRO_APP_ENVIRONMENT__ = false } = tmpWindow;
    return !!__MICRO_APP_NAME__ && __MICRO_APP_ENVIRONMENT__;
};
export const isMicroAppParent = () => {
    return !!(window as any)?.__MICRO_APP_BASE_APPLICATION__;
};
/**
 * @desc 获取真实window（即主应用window）
 * @link  https://jd-opensource.github.io/micro-app/docs.html#/zh-cn/env?id=__micro_app_base_application__
 */
export const getRawWindow = () => {
    return isMicroAppChildren() ? (window as any).rawWindow || $window : $window;
};
/**
 * @desc 获取真实document（即主应用document）
 * @link  https://jd-opensource.github.io/micro-app/docs.html#/zh-cn/env?id=__micro_app_base_application__
 */
export const getRawDocument = () => {
    return isMicroAppChildren() ? (window as any).rawDocument || $document : $document;
};
export function openWindow(uri: string, target = '_blank', config?: IOpenConfig) {
    const {
        isRedirectToUmuApp = false,
        _window = getRawWindow(),
        isOpenDrawer = false,
        enableMideaMiniAppNewVersion = true,
    } = config || {};
    if (isFromMideaMiniApp() && enableMideaMiniAppNewVersion) {
        openUrlInMp(uri);
        return;
    }
    if (isOpenDrawer && isMobileDomain() && !isUMUWebview) {
        // 抽屉格式打开页面，不做跳转
        return onDrawOpenByLink({
            link: uri,
        });
    }
    if (isRedirectToUmuApp && isUMUWebview && umuWebview.isVersionLargerThan('3.4.8')) {
        // uri 不是 umu:// 开头的 且没有https:// 或 http:// 开头的 需要追加m端域名
        let tmpUri = uri;
        if (!/^umu:\/\//.test(uri) && !/^https?:\/\//.test(uri)) {
            tmpUri = `${getMHost()}${uri}`;
        }
        const params = {
            data: {
                url: tmpUri,
                type: SendMsgType.redirectByNative,
            },
            type: SendMsgType.redirectByNative,
        };
        console.log('sendMsgToApp' + params);
        umuWebview.callHandler('sendMsgToApp', params);
        return;
    }
    if (isCreateLinkJump()) {
        const a = document.createElement('a');
        a.href = uri;
        a.dispatchEvent(new Event('click'));
        return;
    }
    if (isInternalJump() || target === '_self') {
        let newUrl: URL;
        try {
            newUrl = new URL(uri);
        } catch (_) {
            newUrl = new URL(uri, window.location.href);
        }
        // const currentUrlUms = getQueryString(USEQuery) === '1';
        // 在存在底部导航的情况下，_window是主应用window，$window是子应用window
        if ((_window as any).isInUSE || ($window as any).isInUSE) {
            newUrl.searchParams.append(USEQuery, '1');
        }
        _window.location.href = newUrl.toString();
        return;
    }
    return _window.open(uri, target);
}

/**
 * 通过点击a标签的方式打开窗口
 * @param {string} url 完整的url
 * @param {string} target 以何种方式打开 '_blank' | '_self'
 */
export const openWindowWithLink = (url: string, target: '_blank' | '_self' = '_blank') => {
    url = /^http/.test(url) ? url : `http://${url}`;
    if (target === '_self' || isInternalJump()) {
        location.href = url;
        return;
    }
    const alink = document.createElement('a');
    alink.href = url;
    alink.target = target;
    alink.click();
};

/**
 * 判断当前页面是否在iframe里 ，
 * 主要作用还是判断是否嵌入自己页面里边的比如im中，需要做些业务处理，但是嵌入第三方域名不能影响这些业务
 * true = in iframe
 * false = not in iframe
 */
export function isInIframe() {
    let inFrame = false;
    try {
        inFrame = window.self !== window.parent;
    } catch (e) {
        inFrame = true;
    }

    // 嵌入了第三方域名不做嵌入算, 只有同一一级域名才能设置这个
    try {
        document.domain = document.domain;
    } catch (e) {
        inFrame = false;
    }
    return inFrame;
}
